export default {"src":"/_next/static/media/solar_smart-home-outline.bc1368ef.svg","height":47,"width":50,"blurWidth":0,"blurHeight":0};